import { createSlice } from "@reduxjs/toolkit";
import {
  createAdmin,
  createAgent,
  updateAdmin,
  updateAgent,
  fetchAdmins,
  fetchAgents,
  deleteUser,
} from "../thunks/userThunks";

const userSlice = createSlice({
  name: "users",
  initialState: {
    admins: [],
    agents: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearUserError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // fetchAdmins
    builder
      .addCase(fetchAdmins.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.admins = action.payload;
        state.loading = false;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // fetchAgents
    builder
      .addCase(fetchAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.agents = action.payload;
        state.loading = false;
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // createAdmin
    builder
      .addCase(createAdmin.fulfilled, (state, action) => {
        state.admins.unshift(action.payload);
      })
      .addCase(createAdmin.rejected, (state, action) => {
        state.error = action.payload;
      });

    // createAgent
    builder
      .addCase(createAgent.fulfilled, (state, action) => {
        state.agents.unshift(action.payload);
      })
      .addCase(createAgent.rejected, (state, action) => {
        state.error = action.payload;
      });

    // updateAdmin
    builder
      .addCase(updateAdmin.fulfilled, (state, action) => {
        const idx = state.admins.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.admins[idx] = action.payload;
      })
      .addCase(updateAdmin.rejected, (state, action) => {
        state.error = action.payload;
      });

    // updateAgent
    builder
      .addCase(updateAgent.fulfilled, (state, action) => {
        const idx = state.agents.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.agents[idx] = action.payload;
      })
      .addCase(updateAgent.rejected, (state, action) => {
        state.error = action.payload;
      });

    // deleteUser
    builder
      .addCase(deleteUser.fulfilled, (state, action) => {
        const id = action.payload;
        state.admins = state.admins.filter((a) => a.id !== id);
        state.agents = state.agents.filter((a) => a.id !== id);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearUserError } = userSlice.actions;
export default userSlice.reducer;
